import React from 'react';
import { TestimonialLayout } from './testimonials/TestimonialLayout';
import { TestimonialHeader } from './testimonials/TestimonialHeader';
import { TestimonialMetric } from './testimonials/TestimonialMetric';
import { TestimonialQuote } from './testimonials/TestimonialQuote';
import { Brain, Heart, Shield } from 'lucide-react';
import { IMAGE_PATHS } from '@/utils/images';

export const TestimonialsSection: React.FC = () => {
  const metrics = [
    {
      icon: Brain,
      label: "Learning Progress",
      value: "90%",
      detail: "9 of 10 milestones reached",
      color: "text-neon-green"
    },
    {
      icon: Heart,
      label: "Health Score",
      value: "85%",
      detail: "17 of 20 milestones reached",
      color: "text-neon-purple"
    },
    {
      icon: Shield,
      label: "Life Security",
      value: "92%",
      detail: "18 of 20 milestones reached",
      color: "text-yellow-400"
    }
  ];

  return (
    <TestimonialLayout>
      <div className="relative">
        {/* Hero Image with Error Handling */}
        <div className="relative h-[80vh] overflow-hidden">
          <img 
            src={IMAGE_PATHS.OLLIE_AVATAR}
            alt="Ollie"
            className="w-full h-full object-cover"
            onError={(e) => {
              const img = e.target as HTMLImageElement;
              img.onerror = null;
              img.src = IMAGE_PATHS.FALLBACK;
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />
        </div>

        {/* Content overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-12">
          <div className="max-w-7xl mx-auto">
            <div className="space-y-6 max-w-2xl">
              <TestimonialHeader 
                title="Meet Ollie: A LifeTrack Success Story 🚀"
                subtitle="At just 16, Ollie has already started taking control of his future using LifeTrack."
              />

              <div className="grid grid-cols-3 gap-4">
                {metrics.map((metric) => (
                  <TestimonialMetric key={metric.label} {...metric} />
                ))}
              </div>

              <TestimonialQuote 
                quote="What I love most about LifeTrack is how it makes planning for my future feel like leveling up in a game. Every small win counts towards my bigger goals."
                author="Ollie"
              />
            </div>
          </div>
        </div>
      </div>
    </TestimonialLayout>
  );
};